import {view, media, tokens, type CssProperties} from '@sail/ui';
import {Header} from 'src/v2/components/screen/Header';
import {Footer} from 'src/v2/components/screen/Footer';
import {isEmbedded} from 'src/utils/utils';
import {MEDIA_QUERIES} from 'src/v2/util/mediaQueries';

const embeddedStyles: {layout: CssProperties; footer: CssProperties} = {
  layout: {
    height: 'fit',
    padding: '4px',
    [media.down(tokens.viewport.medium)]: {
      padding: '4px',
    },
  },
  footer: {
    paddingTop: '16px',
    [MEDIA_QUERIES.mediumWidth]: {
      paddingTop: '16px',
    },
  },
};

export const Layout = ({children}: {children: React.ReactNode}) => {
  const embedded = isEmbedded();

  return (
    <view.div
      css={{
        width: 'fill',
        height: '100dvh',
        stack: 'y',
        gapY: 'space.0',
        backgroundColor: 'surface',
        // Display scroll bars only if the content is overflowing
        overflow: 'auto',
        paddingBottom: 'space.500',
        [media.down(tokens.viewport.medium)]: {
          paddingBottom: 'large',
        },
        ...(embedded && embeddedStyles.layout),
      }}
      data-testid="v2-layout"
    >
      {embedded ? null : <Header />}
      {children}
      <view.div
        css={{
          paddingTop: 'space.500',
          [MEDIA_QUERIES.mediumWidth]: {
            paddingTop: 'space.0',
          },
          height: 'fit',
          ...(embedded && embeddedStyles.footer),
        }}
      >
        <Footer />
      </view.div>
    </view.div>
  );
};
